import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {Exemption_3_5} from '@portbase/bezoekschip-service-typescriptmodels';

@Component({
    selector: 'app-visit-exemptions-exemption-3-5',
    templateUrl: './exemption_3_5.component.html',
    styleUrls: ['./exemption_3_5.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_3_5Component extends ExemptionBaseComponent {
  @Input() exemption: Exemption_3_5;
}

